import React from "react";
import cx from "classnames";
import { getYear } from "date-fns";
import { useTranslation } from "i18n";
import { focusStyle } from "../../constants";
import FooterSection from "./components/FooterSection";
import FooterLink from "./components/FooterLink";
import { ReactComponent as SpotlightLogoWhiteSvg } from "../../../../../../assets/svg/Spotlight-Logo-white.svg";
import { ReactComponent as YoutubeIcon } from "../../../../../images/svg/icons/youtube.svg";
import { ReactComponent as FacebookIcon } from "../../../../../images/svg/icons/facebook.svg";
import { ReactComponent as InstagramIcon } from "../../../../../images/svg/icons/instagram.svg";
import { ReactComponent as TiktokIcon } from "../../../../../images/svg/icons/tiktok.svg";
import { ReactComponent as LinkedInIcon } from "../../../../../images/svg/icons/linkedin.svg";
import FooterSocialLink from "./components/FooterSocialLink";

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = getYear(new Date());

  return (
    <footer className="bg-color-neutral-one text-grey-fog-1 mt-auto print:hidden">
      <div className="container-sl flex flex-col gap-[15px] px-[15px] pb-5 pt-[15px]">
        <a
          href="https://www.spotlight.com"
          className={cx("w-content", focusStyle)}
        >
          <SpotlightLogoWhiteSvg height={40} className="mr-auto" />
        </a>
        <div className="flex flex-col gap-[30px] md:flex-row">
          <FooterSection title={t("common:nav.footer.section.aboutSpotlight")}>
            <FooterLink to="https://www.spotlight.com/about-us/">
              {t("common:nav.links.workWithUs")}
            </FooterLink>
            <FooterLink to="https://www.spotlight.com/our-partners/">
              {t("common:nav.links.partners")}
            </FooterLink>
          </FooterSection>
          <FooterSection title={t("common:nav.footer.section.helpAndSupport")}>
            <FooterLink to="https://www.spotlight.com/help-and-faqs/">
              {t("common:nav.links.helpAndFaq")}
            </FooterLink>
            <FooterLink to="https://support.spotlight.com/hc/en-us">
              {t("common:nav.links.contact")}
            </FooterLink>
            <FooterLink to="https://status.spotlight.com">
              {t("common:nav.links.websiteStatus")}
            </FooterLink>
          </FooterSection>
          <FooterSection title={t("common:nav.footer.section.smallPrint")}>
            <FooterLink to="https://www.spotlight.com/the-small-print/terms-conditions/">
              {t("common:nav.links.termsConditions")}
            </FooterLink>
            <FooterLink to="https://www.spotlight.com/the-small-print/privacy-policy/">
              {t("common:nav.links.privacyPolicy")}
            </FooterLink>
            <FooterLink to="https://www.spotlight.com/the-small-print/safeguarding-policy">
              {t("common:nav.links.safeguardPolicy")}
            </FooterLink>
          </FooterSection>
        </div>
        <div className="flex flex-col-reverse justify-between gap-[15px] text-xs md:flex-row">
          <div>
            <div>{t("common:nav.footer.copyright", { year: currentYear })}</div>
            <div>{t("common:nav.footer.address")}</div>
          </div>
          <div className="flex gap-2">
            <FooterSocialLink to="https://www.youtube.com/user/TheUKSpotlight">
              <YoutubeIcon height={12} />
            </FooterSocialLink>
            <FooterSocialLink to="https://www.facebook.com/spotlightuk">
              <FacebookIcon height={12} />
            </FooterSocialLink>
            <FooterSocialLink to="https://www.instagram.com/spotlightuk">
              <InstagramIcon height={12} />
            </FooterSocialLink>
            <FooterSocialLink to="https://www.tiktok.com/@spotlightuk">
              <TiktokIcon height={12} />
            </FooterSocialLink>
            <FooterSocialLink to="https://www.linkedin.com/company/spotlight_4">
              <LinkedInIcon height={12} />
            </FooterSocialLink>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
